import { passwordRegex } from "../../../../utils/ValidationUtils";
import { MFA_TYPE_VALUES } from "./enum/mfaTypes";

export const USER_VALIDATION_RULES = {
  emailAddress: {
    isRequiredTrim: {
      value: true,
    },
    regex: {
      value: {
        pattern: /^$|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
        customMessageKey: "validation.customMessages.emailAddressRegex",
      },
    },
  },
  firstName: {
    isRequiredTrim: {
      value: true,
    },
    noSpacesBeginning: {
      value: true,
    },
  },
  lastName: {
    isRequiredTrim: {
      value: true,
    },
    noSpacesBeginning: {
      value: true,
    },
  },
  mfaType: {
    isRequiredIn: {
      value: MFA_TYPE_VALUES,
    },
  },
  password: {
    regex: {
      value: {
        pattern: passwordRegex,
        customMessageKey: "validation.customMessages.passwordRegex",
      },
    },
  },
  roleId: {
    isRequiredTrim: {
      value: true,
    },
  },
  associatedBu: {
    isRequiredTrim: {
      value: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/users/userValidationRules.js